import styled from '@emotion/styled'
export const StyleTextAreaWrapper = styled.div`
  display: flex;
`
export const StyleTextArea = styled.textarea<any>`
  width: 100%;
  border-radius: 6px;
  font-size: 14px;
  padding: 10px;
  box-sizing: border-box;
  border: 1px solid
    ${(props) =>
      props?.hasError
        ? props.theme.colors.danger
        : !!props?.isFocus
          ? props.theme.colors.primary
          : props.theme.colors.borderColor};
  tab-size: 4;
  outline: none;
  white-space: pre-wrap;
  background-color: transparent;
  color: ${(props) => props.theme.colors.text};
  &::placeholder {
    font-size: 12px;
    color: ${(props) => props.theme.colors.placeholder};
    /* letter-spacing: 0.25px; */
    line-height: 16px;
  }
  ::-ms-input-placeholder {
    color: ${(props: any) => props.theme.colors.grey100};
    font-size: 12px;
  }
  ${(props) => props.styleInput}
  min-height: ${(props: any) => props.minHeight || 120}px;
`
